import { SharedVideo, VideoDto } from './media-studio.model';

export class VideoListResponse {
  page: number;
  pageSize: number;
  total: number;
  data: VideoDto[];
  totalPages: number;
}

export class SharedVideoResponse {
  page: number;
  pageSize: number;
  total: number;
  totalPages: number;
  data: SharedVideo;
}
